import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const PUZZLING_LETTERS_ACTIVITY_FRAGMENT = gql `
  fragment PuzzlingLettersActivityFragment on PuzzlingLettersActivity {
    rounds {
      answer
      answerAudio {
        id
        audio {
          ...AssetFragment
        }
      }
      answerImage {
        id
        image {
          ...AssetFragment
        }
      }
      id
      letter
    }
  }
  ${ASSET_FRAGMENT}
`;
export default PUZZLING_LETTERS_ACTIVITY_FRAGMENT;
